import { render } from "./UserPost.vue?vue&type=template&id=5bd54d34"
const script = {}

import exportComponent from "/home/mitch/frontend/demoenv/demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__